module.exports = __webpack_public_path__ + "img/logo.46ba33f.png";